/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef , useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'
import * as THREE from "three";

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('./models/steve.glb')
  const { actions } = useAnimations(animations, group)

  useEffect(() => {
    let animate = actions['Armature|mixamo.com|Layer0']
    animate.loop = THREE.LoopOnce;
    animate.clampWhenFinished = true;
    props.setAnimate(animate)
  }, [])
  
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group name="Armature" rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
          <primitive object={nodes.mixamorigHips} />
          <group name="body001">
            <skinnedMesh castShadow name="Mesh001" geometry={nodes.Mesh001.geometry} material={materials['body_MAT.004']} skeleton={nodes.Mesh001.skeleton} />
            <skinnedMesh castShadow name="Mesh001_1" geometry={nodes.Mesh001_1.geometry} material={materials['head_MAT.004']} skeleton={nodes.Mesh001_1.skeleton} />
            <skinnedMesh castShadow name="Mesh001_2" geometry={nodes.Mesh001_2.geometry} material={materials['eyes_MAT.001']} skeleton={nodes.Mesh001_2.skeleton} />
          </group>
          <skinnedMesh castShadow name="cloth001" geometry={nodes.cloth001.geometry} material={materials['cloth_MAT.004']} skeleton={nodes.cloth001.skeleton} />
          <skinnedMesh castShadow name="hair001" geometry={nodes.hair001.geometry} material={materials['hair_MAT.004']} skeleton={nodes.hair001.skeleton} />
          <skinnedMesh castShadow name="hat001" geometry={nodes.hat001.geometry} material={materials.hat_MAT} skeleton={nodes.hat001.skeleton} />
          <skinnedMesh castShadow name="jacket001" geometry={nodes.jacket001.geometry} material={materials.jacket_MAT} skeleton={nodes.jacket001.skeleton} />
          <skinnedMesh castShadow name="tooth001" geometry={nodes.tooth001.geometry} material={materials['teeth_MAT.001']} skeleton={nodes.tooth001.skeleton} />
          <skinnedMesh castShadow name="trousers001" geometry={nodes.trousers001.geometry} material={materials['pants_MAT.004']} skeleton={nodes.trousers001.skeleton} />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/steve.glb')
